// Plugins for vuex store
import Vue from "vue";
import { FeathersVuex } from "../feathers/feathers-client";
import createPersistedState from "vuex-persistedstate";

//feathers vuex service plugins
import auth from "./feathers-vuex-plugins/store.auth";
import users from "./feathers-vuex-plugins/services/users";
import tenants from "./feathers-vuex-plugins/services/tenants";
import faxes from "./feathers-vuex-plugins/services/faxes";
import features from "./feathers-vuex-plugins/services/features";
import huntlists from "./feathers-vuex-plugins/services/huntlists";
import ivrs from "./feathers-vuex-plugins/services/ivrs";
import queues from "./feathers-vuex-plugins/services/queues";
import voicemails from "./feathers-vuex-plugins/services/voicemails";
import devices from "./feathers-vuex-plugins/services/devices";
import devicemodels from "./feathers-vuex-plugins/services/device-models";
import paginggroups from "./feathers-vuex-plugins/services/paging-groups";
import callblocking from "./feathers-vuex-plugins/services/call-blocking";
import conferencebridges from "./feathers-vuex-plugins/services/conference-bridges";
import numberporting from "./feathers-vuex-plugins/services/number-porting";
import portinorders from "./feathers-vuex-plugins/services/port-in-orders";
import dids from "./feathers-vuex-plugins/services/dids";
import locations from "./feathers-vuex-plugins/services/locations";
import extensions from "./feathers-vuex-plugins/services/extensions";
import callhistory from "./feathers-vuex-plugins/services/call-history";
import phonebookentries from "./feathers-vuex-plugins/services/phonebook-entries";
import queuemembers from "./feathers-vuex-plugins/services/queuemembers";
import musiconholds from "./feathers-vuex-plugins/services/music-on-holds";
import customs from "./feathers-vuex-plugins/services/customs";
import mediafiles from "./feathers-vuex-plugins/services/mediafiles";
import conditions from "./feathers-vuex-plugins/services/conditions";
import donotcalls from "./feathers-vuex-plugins/services/donotcalls";
import shortnumbers from "./feathers-vuex-plugins/services/short-numbers";
import phonebooks from "./feathers-vuex-plugins/services/phonebooks";
import queuemembersAllowed from "./feathers-vuex-plugins/services/queuemembers-allowed";

import providers from "./feathers-vuex-plugins/services/providers";
import routingProfiles from "./feathers-vuex-plugins/services/routing-profiles";
import buttonLayouts from "./feathers-vuex-plugins/services/button-layouts";
import branches from "./feathers-vuex-plugins/services/branches";
import partners from "./feathers-vuex-plugins/services/partners";
import callCampaigns from "./feathers-vuex-plugins/services/call-campaigns";
import userSettings from "./feathers-vuex-plugins/services/user-settings";

//feathers vuex dummy services to exploit feathers vuex functionality
import queuecallers from "./feathers-vuex-plugins/dummy-services/queuecallers";
import currentcalls from "./feathers-vuex-plugins/dummy-services/currentcalls";
import mycurrentcalls from "./feathers-vuex-plugins/dummy-services/mycurrentcalls";
import myfaxes from "./feathers-vuex-plugins/dummy-services/myfaxes";
import myparkedcalls from "@/vuex/feathers-vuex-plugins/dummy-services/myparkedcalls";
import queueDashQueues from './feathers-vuex-plugins/dummy-services/queue-dashboard-queues';
import queueDashAgents from './feathers-vuex-plugins/dummy-services/queue-dashboard-agents';
import queueDashWaiting from './feathers-vuex-plugins/dummy-services/queue-dashboard-waiting';
import queueDashActive from './feathers-vuex-plugins/dummy-services/queue-dashboard-active';
import queueDashAgentAggregates from "./feathers-vuex-plugins/dummy-services/queue-dashboard-agent-aggregates";

Vue.use(FeathersVuex);

const persistedStateVars = [
  "layout",
  "selectedTenant",
  "audioInputDeviceId",
  "softphoneEnabled",
  "lastDashboardQueue",
  "lastManagerDashboardLayout",
  "inboundRingVolume",
  "outboundRingVolume",
  "callWaitingVolume",
  "incomingRingTone",
  "whatsNewBadge",
  "plantronicsEnabled"
];

export default [
  createPersistedState({ paths: persistedStateVars }),
  auth,
  callblocking,
  callhistory,
  conferencebridges,
  currentcalls,
  devices,
  devicemodels,
  dids,
  extensions,
  faxes,
  features,
  huntlists,
  ivrs,
  locations,
  mycurrentcalls,
  myparkedcalls,
  myfaxes,
  numberporting,
  paginggroups,
  phonebookentries,
  portinorders,
  queues,
  queuecallers,
  queuemembers,
  tenants,
  users,
  voicemails,
  musiconholds,
  customs,
  mediafiles,
  conditions,
  donotcalls,
  shortnumbers,
  phonebooks,
  queuemembersAllowed,
  providers,
  routingProfiles,
  buttonLayouts,
  branches,
  partners,
  callCampaigns,
  userSettings,
  queueDashQueues,
  queueDashAgents,
  queueDashWaiting,
  queueDashActive,
  queueDashAgentAggregates
];
